import ModalManager from '@ebay/nice-modal-react';
import { PageForm } from '/src/layouts/page';
import { useAuthStateContext } from '/src/features/auth/context/authContext';
import Button from '/src/components/UI/Button/Button';
import getNameFromEmail from '/src/utils/getNameFromEmail';
import capitalizeFirstLetter from '/src/utils/capitalizeFirstLetter';
import reviewerColor from '/src/utils/reviewerColor';
import ChangePasswordModal from '/src/features/account/components/ChangePasswordModal/ChangePasswordModal';
import MyActivity from '/src/features/account/components/MyActivity/MyActivity';
import './ProfilePage.css';

function ProfilePage() {
    const { user } = useAuthStateContext();

    const { firstName, lastName } = getNameFromEmail(user?.email);
    const displayName = [firstName, lastName].filter(Boolean).map(capitalizeFirstLetter).join(' ') || user?.email || 'Unknown user';
    const initials = ((firstName?.[0] || '') + (lastName?.[0] || firstName?.[1] || '')).toUpperCase() || '?';
    const isAdmin = !!user?.is_admin;

    return (
        <PageForm className="profile-page">
            <div className="profile-header">
                <div className="profile-avatar" style={{ background: reviewerColor(user?.email || displayName) }}>
                    {initials}
                </div>
                <div className="profile-header-info">
                    <h2>{displayName}</h2>
                    <span className="profile-email">{user?.email}</span>
                    <span className={"profile-role-badge " + (isAdmin ? "admin" : "user")}>
                        <i className="fa-solid fa-shield-halved"></i>
                        {isAdmin ? "Administrator" : "User"}
                    </span>
                </div>
            </div>

            <div className="profile-section">
                <div className="profile-section-icon">
                    <i className="fa-solid fa-key"></i>
                </div>
                <div className="profile-section-text">
                    <h3>Password</h3>
                    <p>Change your password regularly to keep your account secure.</p>
                </div>
                <Button
                    className="validate"
                    label="Change password"
                    onClick={() => ModalManager.show(ChangePasswordModal)}
                />
            </div>

            <div className="profile-section activity">
                <div className="profile-section-header">
                    <div className="profile-section-icon">
                        <i className="fa-solid fa-clock-rotate-left"></i>
                    </div>
                    <div className="profile-section-text">
                        <h3>Activity</h3>
                        <p>The conversations and criteria you've recently worked on.</p>
                    </div>
                </div>
                <MyActivity />
            </div>
        </PageForm>
    );
}

export default ProfilePage;
